var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"page-title__hd",style:({backgroundColor: _vm.bgColor})},[_c('div',{staticClass:"page-title__en"},[_vm._v(_vm._s(_vm.enText))]),(_vm.showText_)?_c('div',{staticClass:"page-title__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }